export interface INotification {
  id?: string;
  icon: string;
  link: string;
  message: string;
  page: string;
  title: string;
  type: string;
}

export interface IUser {
  portalModuleBaseUrl: string | undefined;
  // TODO enumify
  audience: string;
  fromInternal: boolean;
  email?: string;
  department?: string;
  domainGroup?: string;
  organizationalUnit?: string;
  identity: { firstName?: string; lastName?: string; fullName?: string };
  iamPermissions?: string[];
  features?: string[];
}

export enum UserType {
  Client = "client",
  Public = "public",
  Int = "int",
}
